import { render } from "./App.vue?vue&type=template&id=a4f86238"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a4f86238&lang=scss"

import exportComponent from "/root/work/static-qxs-webinar-vue_pre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__